import type { ColorPair } from '~/models/Presentation/BasePage'

const colorPairs: Record<string, ColorPair> = {
  'Gerd': { text: '#65C7B2', background: '#00423E', isDark: true },
  'Gerd 2': { text: '#00423E', background: '#65C7B2', isDark: false },
  'Gina': { text: '#F38F8F', background: '#00423E', isDark: true },
  'Gina 2': { text: '#00423E', background: '#F38F8F', isDark: false },
  'Gitte': { text: '#F9E16D', background: '#006A52', isDark: true },
  'Gitte 2': { text: '#006A52', background: '#F9E16D', isDark: false },
  'Gøril': { text: '#D4EBEC', background: '#095456', isDark: true },
  'Gøril 2': { text: '#095456', background: '#D4EBEC', isDark: false },
  'Ronald': { text: '#FC6371', background: '#530E20', isDark: true },
  'Ronald 2': { text: '#530E20', background: '#FC6371', isDark: false },
  'Ruben': { text: '#F38F8F', background: '#172B54', isDark: true },
  'Ruben 2': { text: '#172B54', background: '#F38F8F', isDark: false },
  'Rasmus': { text: '#F9E16D', background: '#474747', isDark: true },
  'Rasmus 2': { text: '#474747', background: '#F9E16D', isDark: false },
}

export default () => {
  const getColorPair = (colorPairName: string) => colorPairName ? colorPairs[colorPairName] : colorPairs['Gerd']

  return {
    getColorPair,
  }
}
